import request from "@/axios/http";

// 发布缩水软件 - 收费模式
// 接口：POST /stage-api/software/paid/release
export function softwarePaidRelease(data) {
  return request({
    url: "/stage-api/software/paid/release",
    method: "post",
    data,
  });
}

// 发布缩水软件 - 免费模式
// 接口：POST /stage-api/software/free/release
// 业务语义：我已经有软件了，现在免费发布上架（isFree=1）
export function softwareFreeRelease(data) {
  return request({
    url: "/stage-api/software/free/release",
    method: "post",
    data,
  });
}

// 发布定制需求 - 我还没有软件，发布需求找人开发
// 接口：POST /stage-api/software/custom/demand/release
// 业务语义：我还没有软件，现在发布需求找人开发（无软件文件，含开发预算 coin）
export function softwareCustomDemandRelease(data) {
  return request({
    url: "/stage-api/software/custom/demand/release",
    method: "post",
    data,
  });
}

// 我的定制需求列表
// 接口：GET /stage-api/software/custom/demand/my/list
// Query 参数（均通过 params 透传）：
//   - pageNum    integer<int32>  查询页码，必需
//   - pageSize   integer<int32>  每页条数，必需
//   - keyword    可选，按定制软件标题搜索
//   - auditStatus 可选，按审核状态筛选（0待审核 1已通过 2已拒绝，以实际后端为准）
// 返回约定：{ rows: [...], total } 或 裸数组（按项目响应拦截器兼容处理）
// 注意：调用方需自行在 params 中带上 pageNum / pageSize（本函数原样透传）
export function softwareCustomDemandMyList(params) {
  return request({
    url: "/stage-api/software/custom/demand/my/list",
    method: "get",
    params: {
      ...(params || {}),
      pageNum:
        params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
      pageSize:
        params && params.pageSize !== undefined ? Number(params.pageSize) : 10,
    },
  });
}

// 定制软件需求详情（点击「查看详情」时调用）
// 接口：GET /stage-api/software/custom/demand/{id}
// 路径参数：id = 定制软件需求ID
// 返回约定：{ code, msg, data }（带 code 包装），data 即需求详情对象；
//          部分部署可能直接返回裸对象，调用方按 res.data 优先、回退 res 处理
export function softwareCustomDemandDetail(id) {
  return request({
    url: "/stage-api/software/custom/demand/" + id,
    method: "get",
  });
}

// 申请有偿转让软件
// 接口：POST /stage-api/software/paid/transfer
// 业务语义：我已经有软件了，现在申请有偿转让（固定收费，isFree=0，coin 必填）
// Body: { id: 软件ID<int64>, coin: 转让定价<bigdecimal>(1~100) }
export function softwarePaidTransfer(data) {
  return request({
    url: "/stage-api/software/paid/transfer",
    method: "post",
    data,
  });
}

// 创建有偿转让软件订购订单
// 接口：POST /stage-api/software/paid/transfer/order
// 业务语义：为有偿转让软件创建订购订单（买家侧下单/支付）
// Body: { softwareId: 软件ID<int64>(必需), payType?: 支付方式(balancepay余额/wxpay微信/alipay支付宝),
//         notifyUrl?: 异步回调, returnUrl?: 同步回调, uuid?: 防重复提交签名(空则后台生成) }
export function softwarePaidTransferOrder(data) {
  return request({
    url: "/stage-api/software/paid/transfer/order",
    method: "post",
    data,
  });
}

// 处理软件列表点击量（点击软件交易师等进入详情时调用）
// 接口：POST /stage-api/software/{id}/hits
// 路径参数 id：软件ID<int64>
export function softwareHits(id) {
  return request({
    url: `/stage-api/software/${id}/hits`,
    method: "post",
  });
}

// 软件发布明细（我发布的）列表查询
// 接口：GET /stage-api/software/release/details
// 说明：用户文档标注为 Query 参数（分页 + 可选筛选）
//   - pageNum / pageSize 必需（分页）
//   - keyword 可选（按软件名称搜索）
//   - auditStatus 可选（按审核状态筛选：0待审核 1已通过 2已拒绝，以实际后端为准）
//   - 其余实体字段（formula/introduction/softwareName 等）为返回字段，查询时无需传递
export function softwareReleaseDetails(params) {
  return request({
    url: "/stage-api/software/release/details",
    method: "get",
    params,
  });
}

// 软件发布明细（综合明细）列表查询
// 接口完整地址：http://6.36886.net/stage-api/software/release/summary/list
// 约定：代码里去掉协议+域名（http://6.36886.net），但保留 /stage-api 路径前缀
//       （lottery-sss 各环境 baseURL 不含 /stage-api，接口路径需自带 /stage-api）
// 说明：分页 + 筛选，支持 keyword / auditStatus 等参数；响应为软件发布记录实体列表
export function softwareReleaseSummaryList(params) {
  return request({
    url: "/stage-api/software/release/summary/list",
    method: "get",
    params,
  });
}

// 软件来源下拉选项
// 接口：GET /stage-api/software/source
// 用于发布页"软件来源"字段（fabu_software.vue），返回结构兼容：字符串数组 / {dictValue,dictLabel} 数组 / {rows:[...]}
export function softwareSourceList() {
  return request({
    url: "/stage-api/software/source",
    method: "get",
  });
}

// 软件交易师全景详情
// 接口：GET /stage-api/software/trader/profile/{userId}
// 路径参数：userId - 交易师用户ID<int64>
// 返回：交易师个人信息 + 身份标签 + 发布的软件等全景数据（结构以后端实际返回为准）
export function softwareTraderProfile(userId) {
  return request({
    url: "/stage-api/software/trader/profile/" + userId,
    method: "get",
  });
}

// 众筹软件管理列表（dealer.vue 众筹 tab 专用）
// 接口：GET /stage-api/software/custom/manage/list
// Query 参数：
//   - mode  可选，定制模式：personal-个人定制 / crowdfunding-多人众筹
//   - pageNum / pageSize  分页
// 说明：该接口与 softwareList 不同，单独调用；返回约定兼容 {rows,total} / 裸数组
export function softwareCustomManageList(params) {
  return request({
    url: "/stage-api/software/custom/manage/list",
    method: "get",
    params,
  });
}

// 定制软件需求沟通记录列表（留言板块）
// 接口：GET /stage-api/software/custom/message/list
// Query 参数：
//   - customId  integer<int64>  定制软件需求ID（必需）
// 返回约定兼容 {rows,total} / 裸数组
export function softwareCustomMessageList(params) {
  return request({
    url: "/stage-api/software/custom/message/list",
    method: "get",
    params,
  });
}

// 发送定制软件需求沟通记录（留言）
// 接口：POST /stage-api/software/custom/message/send
// Body 参数：
//   - content   string  沟通内容（必需）
//   - customId  integer<int64>  定制软件需求ID（必需）
export function softwareCustomMessageSend(data) {
  return request({
    url: "/stage-api/software/custom/message/send",
    method: "post",
    data,
  });
}

// 定制需求投标列表（我的定制需求详情内展示）
// 接口：GET /stage-api/software/custom/bid/list
// Query 参数：
//   - customId  integer<int64>  定制软件需求ID（必需）
// 返回约定兼容 {rows,total} / 裸数组
export function softwareCustomBidList(params) {
  return request({
    url: "/stage-api/software/custom/bid/list",
    method: "get",
    params,
  });
}

// 选标（选定某条投标记录为中标）
// 接口：POST /stage-api/software/custom/bid/select
// Body 参数（以实际后端为准）：
//   - bidId     integer<int64>  投标记录ID（必需）
//   - customId  integer<int64>  定制软件需求ID（必需）
export function softwareCustomBidSelect(data) {
  return request({
    url: "/stage-api/software/custom/bid/select",
    method: "post",
    data,
  });
}

// 提交投标方案（选标之后调用）
// 接口：POST /stage-api/software/custom/bid/submit
// Body 参数（以实际后端为准）：
//   - customId  integer<int64>  定制软件需求ID（必需）
//   - bidId     integer<int64>  中标投标记录ID（选标后回传）
//   - content   string  投标方案说明（可选）
//   - fileList  array<string>  方案附件路径/ID（可选）
export function softwareCustomBidSubmit(data) {
  return request({
    url: "/stage-api/software/custom/bid/submit",
    method: "post",
    data,
  });
}

// 撤销选标（需求方撤销当前已选中的中标方，需求回到可投标状态）
// 接口：POST /stage-api/software/custom/bid/cancelSelect
// Body 参数（以实际后端为准）：
//   - customId  integer<int64>  定制软件需求ID（必需）
//   - bidId     integer<int64>  当前已选中的投标记录ID（建议携带）
export function softwareCustomBidCancelSelect(data) {
  return request({
    url: "/stage-api/software/custom/bid/cancelSelect",
    method: "post",
    data,
  });
}

// 撤标（已投标后撤回投标）
// 接口：POST /stage-api/software/custom/bid/withdraw?customId=15
export function softwareCustomBidWithdraw(params) {
  return request({
    url: "/stage-api/software/custom/bid/withdraw",
    method: "post",
    params,
  });
}

// 出资认购众筹需求（dealer.vue 众筹列表「众筹」按钮提交）
// 接口：POST /stage-api/software/custom/crowd/join
// Body 参数（application/json）：
//   - amount        number<bigdecimal>  认购金额（元），必须大于 0（必需）
//   - contactPhone  string              联系电话（必需，<=20 字符）
//   - customId      integer<int64>      定制软件需求ID（必需）
//   - remark        string              认购备注（可选）
//   - teamName      string              参与团队/个人名称（必需，<=100 字符）
export function softwareCustomCrowdJoin(data) {
  return request({
    url: "/stage-api/software/custom/crowd/join",
    method: "post",
    data,
  });
}

// 上传主合同文件（选标后需求方/中标方上传合同）
// 乙方上传合同文件（保存合同登记：传入已上传得到的 contractFile 路径 + 方案说明）
// 接口：POST /stage-api/software/custom/contract/upload
//   - contractFile    string  主合同文件路径或附件ID（由公共上传接口 /stage-api/commonFile/upLoadFile 返回）
//   - contractRemark  string  主合同备注 / 方案说明（可选）
//   - customId/bidId  关联字段（可选）
// 文件本身的二进制上传走公共接口 upLoadFile（/stage-api/commonFile/upLoadFile）
export function softwareCustomContractUpload(data) {
  return request({
    url: "/stage-api/software/custom/contract/upload",
    method: "post",
    data,
  });
}

// 定制软件需求资金托管下单
// 接口：POST /stage-api/software/custom/escrow/order
// Body 参数：
//   - amount      number<bigdecimal>  托管金额（元），必须 >=1（必需）
//   - customId    integer<int64>      定制软件需求ID（必需）
//   - bidId       integer<int64>      投标方案ID（可选；为空时使用需求已选中的投标方案）
//   - payType     string              支付方式：balancepay 余额支付（可选）
//   - projectType integer<int32>      资金记录类型：1-首次托管 2-追加托管（可选）
//   - remark      string              备注（可选）
//   - orderNo/notifyUrl/returnUrl/uuid 等按后端需要可选透传
export function softwareCustomEscrowOrder(data) {
  return request({
    url: "/stage-api/software/custom/escrow/order",
    method: "post",
    data,
  });
}

// 申请平台再杀毒（请平台技术再杀毒）
// 接口：GET /stage-api/software/antivirus/apply
// Query 参数：
//   - softwareId  integer<int64>  软件ID（必需）
// 业务语义：用户对已发布软件发起"请平台技术再杀毒"申请，扣除对应缩币
export function softwareAntivirusApply(params) {
  return request({
    url: "/stage-api/software/antivirus/apply",
    method: "post",
    params,
  });
}
